import * as React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import AuthContext from '../../contexts/auth'

const CommunityProtectedRoute: React.FC<RouteProps> = ({ component, ...rest }: any) => {
  const authContext = React.useContext(AuthContext)
  const routeComponent = (props: any) => {
    if (authContext?.isCommunityAdminLoggedIn()) {
      return React.createElement(component, props)
    } else if (authContext?.isRegularUserLoggedIn()) {
      return <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
    } else if (authContext?.isAdminLoggedIn()) {
      return <Redirect to={{ pathname: '/admin/home', state: { from: props.location } }} />
    } else { return <Redirect to={{ pathname: '/community/login', state: { from: props.location } }} /> }
  }
  return <Route {...rest} render={routeComponent} />
}

export default CommunityProtectedRoute
